import type { AdminDomainSelectDto } from '@@types/api.types';
import { TooltipComponent } from '@components/core/tooltip.component';
import React from 'react';

type AdminDomainDependenciesProps = {
  domain: AdminDomainSelectDto;
};

export const AdminDomainDependencies: React.FC<AdminDomainDependenciesProps> = (props) => {
  const { domain } = props;

  const dependencies = [
    { label: 'Assessments', count: domain.dependencyCounts.assessmentsCount },
    {
      label: 'Mission Assessment Tech Uses',
      count: domain.dependencyCounts.missionAssessmentTechnologyUseDomainsCount,
    },
    { label: 'Survey Use Domains', count: domain.dependencyCounts.surveyUseDomainsCount },
    { label: 'Technology Use Domains', count: domain.dependencyCounts.technologyUseDomainsCount },
  ].filter((dependency) => dependency.count > 0);

  return (
    <div className="p-4 rounded-lg border border-gray-200 bg-white">
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2">
          <h3 className="text-sm font-semibold text-gray-900">Usage</h3>
          <TooltipComponent side="top">
            Entities (assessments, technology use domains, survey use domains, etc.) that are using this domain.
          </TooltipComponent>
        </div>

        {domain.totalDependencies === 0 ? (
          <p className="text-sm text-gray-500">This domain is not being used.</p>
        ) : (
          <div className="space-y-1 text-sm">
            {dependencies.map((dependency) => (
              <div
                key={dependency.label}
                className="flex justify-between"
              >
                <span className="text-gray-600">{dependency.label}:</span>
                <span className="font-medium">{dependency.count}</span>
              </div>
            ))}
            <div className="flex font-semibold justify-between pt-1 border-t border-gray-200">
              <span className="text-gray-600">Total:</span>
              <span className="font-medium">{domain.totalDependencies}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
